import { Fragment, useState, useEffect  } from "react";
import { Outlet } from "react-router-dom";
import { Navigation } from "../components";
import { Scrollbars } from "rc-scrollbars";
import SignalRService from "../services/signalR.service";
import { useAuthenticationService } from "../services/authentication.service";
import "./master.layout.css";

let initializationPromise = null;

function MasterLayout() {
  const [isInitializing, setIsInitializing] = useState(true);
  const authService = useAuthenticationService();

  const [margin, setMargin] = useState(56);

  useEffect(() => {
    let isMounted = true;

    if (!initializationPromise) {
      initializationPromise = (async () => {
        try {
          if (!authService.isAuthenticated()) {
            await authService.refreshToken();
          }
        } catch (error) {
          console.error("Authentication initialization error:", error);
        }
      })();
    }

    initializationPromise.finally(() => {
      if (isMounted) {
        setIsInitializing(false);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [authService]);

  if (isInitializing) {
    return <div>Loading...</div>;
  }

  return (
    <Fragment>
      <>
        <div
          style={{
            display: "flex",
            width: "100%",
            flex: 1,
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <SignalRService />
          <Navigation setMargin={setMargin} />
          <Scrollbars
            autoHide
            renderThumbVertical={(props) => <div {...props} className="thumb-vertical" />}
            style={{
              width: "calc(100vw - 50px)",
              height: "100vh",
              thumbColor: "blue",
              marginLeft: margin,
              transition: "margin-left 0.3s ease-out",
            }}
          >
            <div style={{ padding: 20 }}>
              <Outlet />
            </div>
          </Scrollbars>
        </div>
      </>
    </Fragment>
  );
}

export default MasterLayout;
